import SwitchIcon from '@mui/icons-material/SwapHoriz';
import {Box, Fab} from '@mui/material';
import {func, object} from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import {swapCompareSubjects} from '@explorer/actions/compare.js';
import {getFullCompareSubjects} from '@explorer/selectors/compare';

const CompareSwitcher = props => {
  const onSwitchClick = () => {
    props.dispatch(swapCompareSubjects());
  };

  const hidden = !(props.subjects[0] && props.subjects[1]);

  return (
    <Box
      sx={{
        mx: 2,
        visibility: hidden ? 'hidden' : 'visible',
      }}
    >
      <Fab
        aria-label="switch"
        size="small"
        color="secondary"
        onClick={onSwitchClick}
        sx={{
          backgroundColor: 'grey.900',
          color: 'common.white',
          '&:hover': {
            backgroundColor: 'grey.900',
          },
        }}
      >
        <SwitchIcon />
      </Fab>
    </Box>
  );
};

CompareSwitcher.propTypes = {
  dispatch: func.isRequired,
  subjects: object.isRequired,
};

const mapStateToProps = state => ({
  subjects: getFullCompareSubjects(state),
});

export default connect(mapStateToProps)(CompareSwitcher);
